/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConsultantViewModel } from './ConsultantViewModel';
import {
    ConsultantViewModelFromJSON,
    ConsultantViewModelFromJSONTyped,
    ConsultantViewModelToJSON,
} from './ConsultantViewModel';
import type { SignatoryViewModel } from './SignatoryViewModel';
import {
    SignatoryViewModelFromJSON,
    SignatoryViewModelFromJSONTyped,
    SignatoryViewModelToJSON,
} from './SignatoryViewModel';
import type { SupportingDocumentViewModel } from './SupportingDocumentViewModel';
import {
    SupportingDocumentViewModelFromJSON,
    SupportingDocumentViewModelFromJSONTyped,
    SupportingDocumentViewModelToJSON,
} from './SupportingDocumentViewModel';

/**
 * 
 * @export
 * @interface CapturedElectronicSigningDetailsViewModel
 */
export interface CapturedElectronicSigningDetailsViewModel {
    /**
     * 
     * @type {Array<SupportingDocumentViewModel>}
     * @memberof CapturedElectronicSigningDetailsViewModel
     */
    supportingDocuments: Array<SupportingDocumentViewModel>;
    /**
     * 
     * @type {Array<SignatoryViewModel>}
     * @memberof CapturedElectronicSigningDetailsViewModel
     */
    signatories: Array<SignatoryViewModel>;
    /**
     * 
     * @type {Array<ConsultantViewModel>}
     * @memberof CapturedElectronicSigningDetailsViewModel
     */
    consultants: Array<ConsultantViewModel>;
}

/**
 * Check if a given object implements the CapturedElectronicSigningDetailsViewModel interface.
 */
export function instanceOfCapturedElectronicSigningDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "supportingDocuments" in value;
    isInstance = isInstance && "signatories" in value;
    isInstance = isInstance && "consultants" in value;

    return isInstance;
}

export function CapturedElectronicSigningDetailsViewModelFromJSON(json: any): CapturedElectronicSigningDetailsViewModel {
    return CapturedElectronicSigningDetailsViewModelFromJSONTyped(json, false);
}

export function CapturedElectronicSigningDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapturedElectronicSigningDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supportingDocuments': ((json['SupportingDocuments'] as Array<any>).map(SupportingDocumentViewModelFromJSON)),
        'signatories': ((json['Signatories'] as Array<any>).map(SignatoryViewModelFromJSON)),
        'consultants': ((json['Consultants'] as Array<any>).map(ConsultantViewModelFromJSON)),
    };
}

export function CapturedElectronicSigningDetailsViewModelToJSON(value?: CapturedElectronicSigningDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'SupportingDocuments': ((value.supportingDocuments as Array<any>).map(SupportingDocumentViewModelToJSON)),
        'Signatories': ((value.signatories as Array<any>).map(SignatoryViewModelToJSON)),
        'Consultants': ((value.consultants as Array<any>).map(ConsultantViewModelToJSON)),
    };
}

